import axios from 'axios';
import { API_ENDPOINTS } from '../../../../apiConfig';
const API_BASE =  `${API_ENDPOINTS.platform}/permissions`;

export interface RoleModulePermission {
    id?: string;
    roleId: string;
    moduleId: string;
    canCreate: boolean;
    canView: boolean;
    canEdit: boolean;
    canDelete: boolean;
    canReport: boolean;
  }

//onst BASE_URL = '/api/permissions';

export const getAllPermissions = () => axios.get(API_BASE);
export const getPermissionById = (id: string) => axios.get(`${API_BASE}/${id}`);
export const createPermission = (data: RoleModulePermission) => axios.post(API_BASE, data);
export const updatePermission = (id: string, data: RoleModulePermission) => axios.put(`${API_BASE}/${id}`, data);
export const deletePermission = (id: string) => axios.delete(`${API_BASE}/${id}`);
export const getPermissionsByRoleId = (roleId: string) => axios.get(`${API_BASE}/role-id-permissions?roleId=${roleId}`);
 
  
  // Create/update permissions in bulk for a role
  export const createPermissionsForRole = (roleId: string, permissions: RoleModulePermission[]) => {
    return axios.post(`${API_BASE}/bulk/${roleId}`, permissions);
  };
  export const updatePermissionsForRole = (roleId: string, permissions: RoleModulePermission[]) => {
    return axios.put(`${API_BASE}/bulk/${roleId}`, permissions);
  }; 